const headerData = [{
		types: "selection",
		columnwidth: 50,
	}, {
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "Year",
		label: "年份",
		columnwidth: 60,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 100,
	},
	{
		prop: "LEVEL3",
		label: "Level3",
		columnwidth: 170,
	},
	{
		prop: "HPCode",
		label: "医院代码",
		columnwidth: 100,
	},
	{
		prop: "HPName",
		label: "医院名称",
		columnwidth: 100,
	},
	{
		prop: "TechnicalOfficesName",
		label: "科室",
		columnwidth: 120,
	},
	{
		prop: "MoneyQuota",
		label: "年度金额BP",
		columnwidth: 100,
	},
	{
		prop: "QuantityQuota",
		label: "年度数量BP",
		columnwidth: 100,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 130,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 130,
	},
	{
		prop: "UpdaterName",
		label: "修改人",
		columnwidth: 130,
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 130,
	}
];
export default headerData;
